<ion-item class="date-time-picker-field bg-light" lines="none" (click)="onDateItemClicked()">
    <div class="dp-ion-item-content-wrap dp-combo-picker-wrap">
        <ion-input
            labelPlacement="floating"
            [label]="'projects.jobs.details.created-label' | translate"
            [value]="creationDateUTCString | date: 'dd.MM.yyyy HH:mm'"
            [readonly]="true"
        ></ion-input>

        <input
            class="dp-ion-input dp-fake-active-input dp-hidden-dummy-input"
            [value]="creationDateUTCString"
            [matDatepicker]="datePicker"
            [readonly]="true"
            [placeholder]="'projects.jobs.details.created-placeholder' | translate"
        />
        <!-- our "timepicker input" which is only needed for inline display -->
        <ion-input class="dp-hidden-dummy-input" [format]="24" [readonly]="true" [ngxTimepicker]="timePicker"></ion-input>
    </div>

    <mat-datepicker
        [touchUi]="utils.isPhone || utils.isTablet"
        disabled="false"
        (closed)="onDatePickerClosed($event)"
        #datePicker
    ></mat-datepicker>

    <ngx-material-timepicker
        timepickerClass="dp-time-picker"
        [format]="24"
        [cancelBtnTmpl]="timePickerCloseBtn"
        [confirmBtnTmpl]="timePickerConfirmBtn"
        [appendToInput]="!utils.isPhone && !utils.isTablet"
        disableAnimation="true"
        (timeSet)="onTimePickerUpdated($event)"
        #timePicker
    ></ngx-material-timepicker>

    <ng-template #timePickerCloseBtn>
        <ion-button fill="clear" class="ion-text-uppercase">{{ 'core.time-picker.cancel-btn' | translate }}</ion-button>
    </ng-template>
    <ng-template #timePickerConfirmBtn>
        <ion-button fill="clear" class="ion-text-uppercase">{{ 'core.time-picker.accept-btn' | translate }}</ion-button>
    </ng-template>
</ion-item>
